import styled from 'styled-components';

export const StyledIconButton = styled.button`
  padding: 0;
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  line-height: initial;
`;
